import { inView30 } from '@helpers/animate';
import { imageUrl } from '@helpers/image';
import { useInView } from '@hooks/useInView';
import UmbracoForm from '@stories/Components/UmbracoForm/UmbracoForm';
import * as React from 'react';
import S from './ContactFormSection.styles';
const ContactFormSection = ({ formConfig, image, title }) => {
    const [refContainer, inView] = useInView({
        rootMargin: inView30,
    });
    return (React.createElement(S.Container, { id: 'enquire', ref: refContainer, "data-inview": inView },
        React.createElement(S.Inner, null,
            React.createElement(S.Title, { id: title.replaceAll(/[\W_]+/g, '-').toLowerCase() }, title),
            React.createElement(S.Image, { alt: image.altText, loading: "lazy", src: imageUrl(image, { width: 631 }) }),
            React.createElement(S.FormWrapper, null, formConfig && (React.createElement(UmbracoForm, { ...formConfig, onSubmitError: () => {
                    refContainer.current?.scrollIntoView({ behavior: 'smooth' });
                }, onSubmitSuccess: () => {
                    refContainer.current?.scrollIntoView({ behavior: 'smooth' });
                } }))))));
};
export default ContactFormSection;
